import { render, staticRenderFns } from "./EditDemographics.vue?vue&type=template&id=20944428&scoped=true&"
import script from "./EditDemographics.vue?vue&type=script&lang=js&"
export * from "./EditDemographics.vue?vue&type=script&lang=js&"
import style0 from "./EditDemographics.vue?vue&type=style&index=0&id=20944428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20944428",
  null
  
)

export default component.exports